export default __webpack_public_path__ + "static/media/appnotecalles.cd1dd801.png";